import PropTypes from 'prop-types'
import { withLocalize } from 'react-localize-redux'

import { Typography } from '@material-ui/core'

import styles from './DeleteKeyForm.module.scss'

const DeleteKeyForm = props => {
  const { onSubmit, translate, isSubmitting } = props

  const onClickCancel = () => {
    props.hideModal()
  }

  const onClickDownload = () => {
    onSubmit()
  }

  return (
    <div className={styles.modalContainer}>
      <Typography className={styles.header}>{translate('integrationsPage.deleteKey')}</Typography>
      <div className={styles.modal}>
        <div className={styles.page}>
          <div className={styles.modalContent}>
            <div>
              <span>{translate('integrationsPage.deleteKeyText')}</span>
            </div>
          </div>
          <div>
            <div className={styles.buttonWrapper}>
              <button
                className={styles.buttonCancelar}
                disabled={isSubmitting}
                onClick={onClickCancel}
              >
                {translate('cancel')}
              </button>
              <button
                className={styles.buttonSiguiente}
                disabled={isSubmitting}
                onClick={onClickDownload}
              >
                {translate('delete').toUpperCase()}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

DeleteKeyForm.propTypes = {
  translate: PropTypes.func.isRequired
}

export default withLocalize(DeleteKeyForm)
